import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, ThumbsUp, Star, Clock } from 'lucide-react';
interface Coupon {
  id: number;
  title: string;
  description: string;
  discount: string;
  code: string;
  expiryDate: string;
  matchScore: number;
  category: string;
  icon: string;
  brandLogo?: string;
}
export function RecommendedCoupons() {
  const [flippedCard, setFlippedCard] = useState<number | null>(null);
  const [savedCoupons, setSavedCoupons] = useState<number[]>([]);
  const recommendations: Coupon[] = [{
    id: 1,
    title: 'SPOTIFY',
    description: 'Based on your music interests',
    discount: '50% OFF',
    code: 'MUSIC50',
    expiryDate: '7 days left',
    matchScore: 98,
    category: 'entertainment',
    icon: '🎵',
    brandLogo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Spotify_icon.svg/1982px-Spotify_icon.svg.png'
  }, {
    id: 2,
    title: 'NIKE',
    description: 'Perfect for your running routine',
    discount: '25% OFF',
    code: 'RUN25',
    expiryDate: '5 days left',
    matchScore: 95,
    category: 'fashion',
    icon: '👟'
  }, {
    id: 3,
    title: 'UBER EATS',
    description: 'Your favorite restaurants',
    discount: '€10 OFF',
    code: 'MEAL10',
    expiryDate: '3 days left',
    matchScore: 92,
    category: 'food',
    icon: '🍔'
  }, {
    id: 4,
    title: 'AMAZON',
    description: 'Items in your wishlist',
    discount: '15% OFF',
    code: 'WISH15',
    expiryDate: '10 days left',
    matchScore: 89,
    category: 'shopping',
    icon: '📦'
  }];
  const handleFlip = (id: number) => {
    setFlippedCard(flippedCard === id ? null : id);
  };
  const handleSave = (e: React.MouseEvent, id: number) => {
    e.stopPropagation();
    if (savedCoupons.includes(id)) {
      setSavedCoupons(savedCoupons.filter(couponId => couponId !== id));
    } else {
      setSavedCoupons([...savedCoupons, id]);
    }
  };
  const handleCopyCode = (e: React.MouseEvent, code: string) => {
    e.stopPropagation();
    navigator.clipboard.writeText(code);
  };
  return <section className="mb-8" data-id="element-295">
      <div className="flex justify-between items-center mb-4" data-id="element-296">
        <div className="flex items-center" data-id="element-297">
          <h2 className="text-xl font-bold" data-id="element-298">Recommended For You</h2>
          <Sparkles className="ml-2 h-5 w-5 text-gray-400" data-id="element-299" />
        </div>
        <a href="#" className="text-gray-500 text-sm hover:underline" data-id="element-300">
          See All
        </a>
      </div>
      <div className="grid grid-cols-2 gap-3" data-id="element-301">
        {recommendations.map(coupon => <div key={coupon.id} className="relative h-[180px] perspective-500" onClick={() => handleFlip(coupon.id)} data-id="element-302">
            <AnimatePresence initial={false} mode="wait" data-id="element-303">
              {flippedCard !== coupon.id ? <motion.div key="front" className="absolute inset-0 rounded-xl shadow-md overflow-hidden cursor-pointer bg-gray-900" initial={{
            rotateY: 180
          }} animate={{
            rotateY: 0
          }} exit={{
            rotateY: -180
          }} transition={{
            duration: 0.4
          }} data-id="element-304">
                  <div className="p-4 text-white h-full flex flex-col" data-id="element-305">
                    <div className="flex justify-between items-start" data-id="element-306">
                      {coupon.brandLogo ? <img src={coupon.brandLogo} alt={coupon.title} className="h-8 w-8 rounded" data-id="element-307" /> : <h3 className="text-xl font-bold" data-id="element-308">{coupon.title}</h3>}
                      <span className="text-2xl" data-id="element-309">{coupon.icon}</span>
                    </div>
                    <div className="mt-auto" data-id="element-310">
                      <p className="text-sm text-white/80 mb-1" data-id="element-311">
                        {coupon.description}
                      </p>
                      <div className="text-2xl font-bold mb-1" data-id="element-312">
                        {coupon.discount}
                      </div>
                      <div className="flex justify-between items-center" data-id="element-313">
                        <div className="flex items-center text-xs bg-white/20 px-2 py-1 rounded-full" data-id="element-314">
                          <ThumbsUp className="h-3 w-3 mr-1" data-id="element-315" />
                          <span data-id="element-316">{coupon.matchScore}% match</span>
                        </div>
                        <div className="flex items-center text-xs" data-id="element-317">
                          <Clock className="h-3 w-3 mr-1" data-id="element-318" />
                          <span data-id="element-319">{coupon.expiryDate}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div> : <motion.div key="back" className="absolute inset-0 bg-white rounded-xl shadow-md overflow-hidden cursor-pointer border-2 border-gray-900" initial={{
            rotateY: -180
          }} animate={{
            rotateY: 0
          }} exit={{
            rotateY: 180
          }} transition={{
            duration: 0.4
          }} data-id="element-320">
                  <div className="p-4 h-full flex flex-col" data-id="element-321">
                    <div className="flex justify-between items-start" data-id="element-322">
                      <h3 className="text-lg font-bold text-gray-900" data-id="element-323">
                        {coupon.title}
                      </h3>
                      <button onClick={e => handleSave(e, coupon.id)} className="p-1 rounded-full hover:bg-gray-100" data-id="element-324">
                        <Star className="h-5 w-5" fill={savedCoupons.includes(coupon.id) ? '#9CA3AF' : 'none'} stroke={savedCoupons.includes(coupon.id) ? '#9CA3AF' : 'currentColor'} data-id="element-325" />
                      </button>
                    </div>
                    <div className="mt-2 text-sm text-gray-600" data-id="element-326">
                      {coupon.description}
                    </div>
                    <div className="mt-auto" data-id="element-327">
                      <div className="bg-gray-100 p-3 rounded-lg mb-3" data-id="element-328">
                        <p className="font-mono text-center font-bold tracking-wider" data-id="element-329">
                          {coupon.code}
                        </p>
                      </div>
                      <div className="grid grid-cols-2 gap-2" data-id="element-330">
                        <button onClick={e => handleCopyCode(e, coupon.code)} className="py-2 bg-gray-100 rounded-lg text-sm font-medium hover:bg-gray-200 transition" data-id="element-331">
                          Copy Code
                        </button>
                        <button className="py-2 rounded-lg text-sm font-medium text-white bg-gray-900 transition" data-id="element-332">
                          Use Now
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}